import { Injectable } from '@angular/core';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from '../../environments/environment';
import { ActionPerformed as localNotificationActionPerformed, LocalNotifications, ScheduleOptions } from '@capacitor/local-notifications';
import { from } from 'rxjs';
import { ActionPerformed, PushNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { AppFeaturesService } from '../portal/app-features.service';
import { Capacitor } from '@capacitor/core';
import { Store } from '@ngxs/store';
import { AuthService } from '../portal/auth.service';
import { MAX_INT } from '../shared/function';
import { AppFeaturesState } from '../portal/app-feature.state';
// import { UserGetNotifications, UserUpdateNotification } from '../portal/userDetails.state';
// import { AppFeaturesState } from '../portal/app-feature.state';

@Injectable({
	providedIn: 'root',
})
export class FirebaseService {
	app: FirebaseApp;
	analytics: Analytics;

	constructor(
		private appFeaturesService: AppFeaturesService,
		private store: Store,
		private authService: AuthService,
		private appFeaturesState: AppFeaturesState
	) {
		this.initializeFirebase();
	}

	async initializeFirebase() {
		if (!await this.appFeaturesState.networkStatus) {
			return;
		}

		this.app = initializeApp(environment.firebase.firebaseConfig);
		this.analytics = getAnalytics(this.app);

		if (Capacitor.isPluginAvailable('PushNotifications')) {
			this.initializePushNotifications();
		}

		if (Capacitor.isPluginAvailable('LocalNotifications')) {
			this.initializeLocalNotification();
		}
	}

	requestPermission() {
		const messaging = getMessaging();
		console.log('messaging', messaging);
		const observable = from(getToken(messaging, { vapidKey: environment.firebase.vapidKey }));
		return observable;
	}

	listen() {
		const messaging = getMessaging();
		onMessage(messaging, (payload) => {
			console.log('Message received. ', payload);
		});
	}

	initializePushNotifications() {
		PushNotifications.addListener('registrationError', (error) => {
			console.log('Error on registration: ' + JSON.stringify(error));
		});
		PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
			console.log('Push received: ' + JSON.stringify(notification));
			// To handle foreground notifications properly we recreate them as local notifications
			this.handleScheduleLocalNotification(notification);
			// this.store.dispatch(new UserGetNotifications());
		});
		PushNotifications.addListener('pushNotificationActionPerformed', (notificationActionPerformed: ActionPerformed) => {
			console.log('localNotificationActionPerformed', JSON.stringify(notificationActionPerformed));
			const data = notificationActionPerformed.notification.data ? notificationActionPerformed.notification.data : undefined;
			const url = data?.redirect_to;
			if (url) {
				this.appFeaturesService.inAppNavigationHandler(url);
				// this.handleNotificationAction(url);
			}
		});
	}

	// handleNotificationAction(url: string) {
	//   if (!this.authService.getToken()) {
	//     return;
	//   }
	//   const notificationInfo = this.appFeaturesService.getNotificationInfoFromQuery(url);
	//   if (!notificationInfo) {
	//     return;
	//   }
	//   if (notificationInfo.usersNotificationsId) {
	//     this.store.dispatch(new UserUpdateNotification(notificationInfo.usersNotificationsId));
	//   }
	// }

	initializeLocalNotification() {
		LocalNotifications.addListener('localNotificationReceived', () => {
			console.log('localNotificationReceived');
			// this.store.dispatch(new UserGetNotifications());
		});
		LocalNotifications.addListener('localNotificationActionPerformed', (event: localNotificationActionPerformed) => {
			console.log('localNotificationActionPerformed', JSON.stringify(event));
			const url = event.notification.extra.navigateTo;
			if (url) {
				console.log('navigating', url);
				this.appFeaturesService.inAppNavigationHandler(url);
				// this.handleNotificationAction(url);
			}
		});
	}

	public handleScheduleLocalNotification(notification: PushNotificationSchema) {
		const data = notification.data ? notification.data : undefined;
		const scheduleTime = data.schedule_at ? parseInt(data.schedule_at, 10) : null;
		const triggerTime = scheduleTime ? new Date(scheduleTime * 1000) : new Date(); // PHP time expected
		const notificationId: number = Date.now() % MAX_INT;
		const localNotificationData = {
			notifications: [
				{
					title: notification.title ?? 'DanceBUG',
					body: notification.body ?? '',
					id: notificationId,
					smallIcon: 'res/drawable/ic_notification',
					schedule: { at: triggerTime, repeats: false },
					extra: {
						navigateTo: data?.redirect_to,
					},
				},
			],
		};
		LocalNotifications.schedule(localNotificationData);
	}

	public async scheduleLocalNotification(options: ScheduleOptions) {
		return await LocalNotifications.schedule(options);
	}

	public async cancelLocalNotification(notificationId: number) {
		await LocalNotifications.cancel({ notifications: [{ id: notificationId }] });
	}
}
